import { render, staticRenderFns } from "./PPReport.vue?vue&type=template&id=6f92ecbd&"
import script from "./PPReport.vue?vue&type=script&lang=js&"
export * from "./PPReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports